import type { ReactNode } from 'react';
import { InfoListRoot } from './styles';

export { InfoListRoot } from './styles';

export type InfoListRow = { label: string; value: ReactNode };

type InfoListProps = {
  rows: InfoListRow[];
  /** 라벨 폭(px). 레거시 작성 90·조회 110 */
  labelWidth?: number;
};

/** 전자결재 본문 라벨·값 줄 목록(레거시 list-bagic-line). 값이 라벨 바로 옆에 왼쪽 정렬 */
const InfoList = ({ rows, labelWidth = 90 }: InfoListProps) => (
  <InfoListRoot>
    {rows.map((row) => (
      <li key={row.label}>
        <div
          className="tit"
          style={{ minWidth: labelWidth, width: labelWidth }}
        >
          {row.label}
        </div>
        <div className="cont">{row.value}</div>
      </li>
    ))}
  </InfoListRoot>
);

export default InfoList;
